var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC2CNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C2C Network"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4874 15.3779C14.8053 14.5052 15.7751 13.1976 16.2278 11.6832C16.6805 10.1688 16.5873 8.54349 15.9646 7.09069C15.3419 5.63788 14.229 4.44969 12.8201 3.73324C11.4111 3.01678 9.79545 2.8175 8.25465 3.17013M13.4874 15.3779V12.7529M13.4874 15.3779H16.1296M6.00465 4.13988C4.69133 5.01581 3.72655 6.32434 3.2781 7.83793C2.82964 9.35152 2.92587 10.9744 3.55006 12.4244C4.17425 13.8744 5.2869 15.0597 6.69454 15.7743C8.10217 16.4889 9.71574 16.6875 11.2546 16.3356M6.00465 4.13988V6.75288M6.00465 4.13988H3.37965",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2CNetwork);
export default __webpack_public_path__ + "static/media/C2C Network.df948e138c97a6caf891a7d24ab09a32.svg";
export { ForwardRef as ReactComponent };